var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.value)?_c('div',{staticClass:"link-container"},[_c('router-link',{staticStyle:{"font-size":"12px"},attrs:{"to":_vm.routerLinkTo}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }